export default {
  props:{
    invertArrow: { type: Boolean, default: false },
    isBMWMoto: { type: Boolean, default: false },
    isHeader: { type: Boolean, default: true },
    kpi: { type: Object, default: undefined },
    monochrome: { type: Boolean, default: false },
    overallByWave: { type: Object, default: undefined },
    showInlineYtd: { type: Boolean, default: false },
    showPrewaves: { type: Boolean, default: true },
    isLostLead: { type: Boolean, default: false },
    isStandalone: { type: Boolean, default: false }
  },

  watch: {
    kpi: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal == null || newVal.Tagged !== undefined) return
        if (!this.overallByWave || !this.overallByWave.Tagged) {
          this.tagOverall(this.overallByWave);
        }
        this.tagItem(newVal, this.overallByWave)
      },
    },
  },

  methods: {

    getSlotName: function(slot) {
      let it = this.getSlot(slot)
      if (it === undefined || it.Result === undefined) return ''
      if (!this.showPrewaves && !_.has(it, "ResultPromoters")) {
        return '';
      }
      if  (slot != 101 && it.Name.length > 5 && it.Name.startsWith('2021')) {
        return it.Name.substr(5);
      }

      return it.Name
    },

    getSlotValue: function(slot) {
      let it = this.getSlot(slot)
      if (it === undefined || it.Result === undefined) return ''
      if (!this.showPrewaves && !_.has(it, "ResultPromoters")) {
        return '';
      }
      return it.Result
    },

    tagItem(newVal, overall) {
      var i;
      for (i = 0; i < overall.SurveyWave.length; i++) {
          let over = overall.SurveyWave[i]
          let item = _.find(newVal.SurveyWave, ['Name', over.Name])
          if(item) item.Slot = over.Slot
      }
      newVal.Tagged = true
    },

    tagOverall(newVal) {
      let last = _.last(newVal.SurveyWave)
      last.Slot = 101
      let index = 0
      _.forEach(newVal.SurveyWave, function(value) {
        if (value.Name.length > 0 && !value.Slot && value !== last) {
          value.Slot = ++index
        }
      });

      newVal.Tagged = true
    },

    getBackgroundClass: function (slot){
      var _kpi = this.kpi
      if (!_kpi || !_kpi.SurveyWave || this.monochrome || !this.showPrewaves) return { 'bc-gray' : true }

      // HACK: Fix Enquiry Reference fast
      if (this.kpi.KpiCode === 'Enquiry Reference') {
        if (slot === 101) {
          return this.getBackgroundForIndicator(0)
        }
       return {'bc-gray' : true}
      }

      let it = this.getSlot(slot)
      if (!it || it.Result === undefined) return {'bc-gray' : true}

      if (this.isBMWMoto) {
        if (it.Result < 60) return { 'bc-red': true }
        else if (it.Result < 80) return  {'bc-yellow' : true}
        else return {'bc-green' : true}
      } else {
        if (this.isLostLead) {
          if (it.Result < 5) { return { 'bc-green': true } }
          else if (it.Result < 10) { return { 'bc-yellow' : true } }
          else { return { 'bc-red' : true } }
        } else {
          if (it.Result < 90) return { 'bc-red': true }
          else if (it.Result < 100) return  {'bc-yellow' : true}
          else return {'bc-green' : true}
        }
      }
    },

    getArrowForItems: function (firstQuarter, nextQuarter) {
      if(!this.invertArrow) {
        if (firstQuarter.Result > nextQuarter.Result) return 3
        if (firstQuarter.Result < nextQuarter.Result) return 2
        return 1
      }

      if (firstQuarter.Result > nextQuarter.Result) return 2
      if (firstQuarter.Result < nextQuarter.Result) return 3
      return 1
    },

    getSlot: function(slot) {
      if (!this.kpi || !this.kpi.SurveyWave)
        return undefined
      return _.find(this.kpi.SurveyWave, ['Slot', slot])
    },

    isNarrow: function(slot) {
      if (!this.kpi || !this.kpi.SurveyWave)
        return false

      let it = _.find(this.kpi.SurveyWave, ['Slot', slot])
      if (it === undefined || it.Result === undefined) {
        return false
      }
      return it.Name.length > 2
    },

    hasWaves() {
      return this.overallByWave && this.overallByWave.SurveyWave && _.size(this.overallByWave.SurveyWave) > 0
    },

    getMinorItemWidth(waves) {
      if (waves < 4) return 16.666
      return 72 / waves
    },

    getMajorItemWidth(waves) {
      if (waves < 4) return 50
      return 28
    }
  },

  computed: {
    waveCount: function () {
      if (!this.hasWaves) return 4
      // Result must be equal or between 4 and 6
      return Math.max(4, Math.min(6, _.size(this.overallByWave.SurveyWave)));
    },

    minorWaveCount: function () {
      return this.waveCount - 1
    },

    getArrow: function() {
      if (!this.kpi || !this.kpi.SurveyWave || _.size(this.kpi.SurveyWave) < 2) {
        return 1
      }

      var arrSize = _.size(this.kpi.SurveyWave)
      return this.getArrowForItems(this.kpi.SurveyWave[arrSize - 2], this.kpi.SurveyWave[arrSize - 1])
    }
  }
};
